import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject ,  Subject } from 'rxjs';
import { HttpClientCachingService } from '../../../../../../core/cache/custom-http-client-caching.service';

@Injectable()

export class DataVehiculosService {
    public newCustomer = false;
    public dataVin = new BehaviorSubject<any>({});
    public guardadoTerceros = new Subject<boolean>();
    public botonGuardar = new Subject<boolean>();
    public botonCancelar = new Subject<boolean>();
    public actualVehicle = new BehaviorSubject<any>({});
    public actualCustomer = new BehaviorSubject<any>({});
    public actualFactura = new BehaviorSubject<any>({});

    public cargadoFromulario = new Subject<boolean>();

    datosGestionForm: any;
    ordenesAbiertas: any[] = [];

    chassis: string;
    constructor(private http: HttpClient, private httpCache: HttpClientCachingService) { }

    observerBotonGuardar() {
        return this.botonGuardar.asObservable();
    }
    setGuardar(value) {
        this.botonGuardar.next(value);
    }
    observerBotonCancelar() {
        return this.botonCancelar.asObservable();
    }
    setCancelar(value) {
        this.botonCancelar.next(value);
    }

    setOrdenesAbiertas(datos) {
        this.ordenesAbiertas = datos;
    }
    getOrdenesAbiertas() {
        return this.ordenesAbiertas;
    }

    observerGuardadoFromTerceros() {
        return this.guardadoTerceros.asObservable();
    }
    setGuardado(value) {
        this.guardadoTerceros.next(value);
    }

    observerCargadoFormulario() {
        return this.cargadoFromulario.asObservable();
    }
    setCargadoFromulario(value) {
        this.cargadoFromulario.next(value);
    }


    observerDataVin() {
        return this.dataVin.asObservable();
    }
    setDataVin(value) {
        this.dataVin.next(value);
    }


    setCustomer(value) {
        this.actualCustomer.next(value);
    }
    observerActualCustomer() {
        return this.actualCustomer.asObservable();
    }
    // Fila escogida de la tabla
    // setDatosTablaGestionForm(datos){
    //     this.datosGestionForm = datos;
    // }
    // getDatosTablaGestionForm(){
    //     return this.datosGestionForm;
    // }
    // Fila escogida solo para el Chassis se utiliza en componente VEhicles.component.ts
    setChassis(datos) {
        this.chassis = datos;
    }
    getChassis() {
        return this.chassis;
    }
    // De la Fila Seleccionada en el listado de pestaña OR/vehiculo
    setVehicle(value) {
        this.actualVehicle.next(value);
    }
    observerActualVehicle() {
        return this.actualVehicle.asObservable();
    }


    setFactura(value) {
        this.actualFactura.next(value);
    }
    observerActualFactura() {
        return this.actualFactura.asObservable();
    }




    getDataOpb(url, params) {
        return this.http.post<any>(url, params);
    }

    getDataVehicle(url, params) {
        return this.http.post<any>(url, params);
    }

    findAlphabeticalPaged(url, params) {
        return this.http.post<any>(url, params);
    }

    getDataAllVehicles(url, params) {
        return this.httpCache.post<any>(url, params);
    }

    getCustumerByCode(url, params) {
        return this.http.post<any>(url, params);
    }

    getCarByChassis(url, params) {
        return this.http.post<any>(url, params);
    }

    getCodigosGarantia(url, params) {
        return this.http.post<any>(url, params);
    }

    getDefaultCarCodes(url, params) {
        return this.http.post<any>(url, params);
    }

    reactivateByChassis(url, params) {
        return this.http.post<any>(url, params);
    }


    getFamilies(url, params) {
        return this.http.post<any>(url, params);
    }

    getContours(url, params) {
        return this.http.post<any>(url, params);
    }

    getEngineMotor(url, params) {
        return this.http.post<any>(url, params);
    }

    getTransmissionsByFamily(url, params) {
        return this.http.post<any>(url, params);
    }

    getCarModel(url, params) {
        return this.http.post<any>(url, params);
    }

    getInformationClientSearch(url, params) {
        return this.http.post<any>(url, params);
    }

    getHistoricSearch(url, params) {
        return this.http.post<any>(url, params);
    }

    updateVinPlate(url, params) {
        return this.http.post<any>(url, params);
    }

    isDuplicatePlate(url, params) {
        return this.http.post<any>(url, params);
    }

    isDuplicateVin(url, params) {
        return this.http.post<any>(url, params);
    }

    getVendor(url, params) {
        return this.http.post<any>(url, params);
    }

    updateCustomer(url, params) {
        return this.http.post<any>(url, params);
    }


}
